/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-constructor */

import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import TanqueCheioTabs from './TanqueCheioTabs';
import TanqueCheioPreview from './TanqueCheioPreview';
import Loading from 'common/components/progress/loading';

class TanqueCheioModal extends React.Component {
  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const {
      visible,
      height,
      form,
      value,
      goBack,
      handleNativeChange,
      handleOpenConfirmation,
      handleCancelClose,
      openConfirmation,
      setOpenConfirmation,
      closeModal,
      onClickProgress,
      router,
      location,
    } = this.props;

    return (
      <Dialog
        open={visible}
        onClose={this.handleClose}
        fullWidth
        fullScreen={isMobile}
        maxWidth="xl"
        PaperProps={{ style: { minHeight: height || '90vh' } }}
        aria-labelledby="tanquecheio-dialog"
      >
        <Box
          sx={{
            backgroundColor: '#323232',
            color: '#fff',
            p: isMobile ? 2 : 3,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Gerenciador Tanque Cheio
          </Typography>
          <IconButton onClick={this.handleClose}>
            <CloseIcon sx={{ color: '#fff' }} />
          </IconButton>
        </Box>

        <DialogContent style={{ padding: 0 }}>
          <Grid container>
            <Grid item xs={12} md={5} sx={{ p: 2 }}>
              <TanqueCheioTabs
                value={value}
                formValues={form}
                goBack={goBack}
                handleNativeChange={handleNativeChange}
                handleOpenConfirmation={handleOpenConfirmation}
                handleCancelClose={handleCancelClose}
                openConfirmation={openConfirmation}
                setOpenConfirmation={setOpenConfirmation}
                closeModal={closeModal}
                onClickProgress={onClickProgress}
                router={router}
                location={location}
              />
            </Grid>

            {!isMobile && (
              <Grid
                item
                xs={12}
                md={7}
                sx={{ borderLeft: '3px solid #f7f7f7', overflowY: 'auto' }}
              >
                {form ? (
                  <TanqueCheioPreview formValues={form} activeSection={value}/>
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%' }}
                  >
                    <Loading />
                  </Box>
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

TanqueCheioModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.number.isRequired,
  form: PropTypes.object, // vem do redux-form
  goBack: PropTypes.func.isRequired,
  handleNativeChange: PropTypes.func.isRequired,
  handleOpenConfirmation: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  setOpenConfirmation: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  onClickProgress: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  form: getFormValues('tanqueCheioForm')(state),
  auth: state.auth,
});

export default connect(mapStateToProps)(TanqueCheioModal);
